
import { useParams } from 'react-router-dom';
import ProductDetailHero from './components/ProductDetailHero';
import ProductFeatures from './components/ProductFeatures';
import ProductSpecifications from './components/ProductSpecifications';
import ComplianceSection from './components/ComplianceSection';
import RelatedProducts from './components/RelatedProducts';
import ProductCTA from './components/ProductCTA';

export default function ManualCallPointsPage() {
  const { id } = useParams();

  const product = {
    id: 3,
    title: 'Manual Call Points',
    category: 'Fire Alarm Systems',
    brand: 'FlameGuardQA',
    model: 'FG-MCP-01',
    certification: 'IP65 Rated',
    status: 'Available',
    image: 'https://readdy.ai/api/search-image?query=Professional%20red%20break%20glass%20manual%20fire%20alarm%20call%20point%20with%20protective%20transparent%20cover%20and%20test%20key%2C%20IP65%20weatherproof%20design%20mounted%20on%20white%20wall%20with%20QCDD%20approval%20marking%20in%20Qatar%20commercial%20building&width=600&height=600&seq=manual-call-point-detail&orientation=squarish',
    description: 'Durable break-glass or resettable manual fire alarm points designed for indoor and outdoor environments. These weatherproof call points provide reliable manual alarm activation in all conditions.'
  };

  const features = [
    'IP65 weatherproof design for all environments',
    'Break-glass or resettable option available',
    'Protective transparent cover included',
    'Test key included for maintenance',
    'Compatible with all fire alarm systems',
    'Vandal-resistant construction',
    'Clear operating instructions',
    'Easy installation and wiring'
  ];

  const specifications = [
    { label: 'Model', value: 'FG-MCP-01' },
    { label: 'Type', value: 'Manual Fire Alarm Call Point' },
    { label: 'Material', value: 'Polycarbonate' },
    { label: 'Mounting', value: 'Surface / Flush' },
    { label: 'Protection Rating', value: 'IP65' },
    { label: 'Operating Voltage', value: '12–24V DC' },
    { label: 'Contact Rating', value: '1A at 30V DC' },
    { label: 'Operating Temperature', value: '-25°C to +70°C' },
    { label: 'Dimensions', value: '90 x 90 x 40mm' },
    { label: 'Weight', value: '200g' },
    { label: 'Certification', value: 'QCDD, EN54' },
    { label: 'Warranty', value: '5 Years' }
  ];

  const relatedProducts = [
    {
      id: 2,
      title: 'Smoke & Heat Detectors',
      image: 'https://readdy.ai/api/search-image?query=Professional%20smoke%20and%20heat%20detectors%20mounted%20on%20white%20ceiling%2C%20QCDD%20approved%20fire%20detection%20sensors%20with%20red%20LED%20indicators%20and%20clean%20technical%20installation%20in%20Qatar%20commercial%20building&width=300&height=200&seq=smoke-detectors-related&orientation=landscape',
      category: 'Fire Alarms',
      compliance: 'EN54 Certified'
    },
    {
      id: 1,
      title: 'Fire Alarm Control Panel',
      image: 'https://readdy.ai/api/search-image?query=Professional%20intelligent%20fire%20alarm%20control%20panel%20with%20digital%20LCD%20display%20and%20red%20indicator%20lights%2C%20advanced%20addressable%20fire%20detection%20system%20with%20network%20connectivity%20and%20QCDD%20approval%20certification%20in%20Qatar%20commercial%20building&width=300&height=200&seq=alarm-control-panel-related2&orientation=landscape',
      category: 'Fire Alarms',
      compliance: 'QCDD Approved'
    },
    {
      id: 4,
      title: 'Fire Alarm Sounders',
      image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20alarm%20sounder%20and%20strobe%20light%20with%20red%20housing%2C%20QCDD%20approved%20audible%20and%20visual%20alarm%20notification%20device%20for%20Qatar%20commercial%20buildings&width=300&height=200&seq=alarm-sounders-related2&orientation=landscape',
      category: 'Fire Alarms',
      compliance: 'QCDD Approved'
    },
    {
      id: 16,
      title: 'Fire Safety Signage',
      image: 'https://readdy.ai/api/search-image?query=Collection%20of%20fire%20safety%20signs%20including%20exit%20signs%2C%20fire%20extinguisher%20location%20signs%20and%20hazard%20warning%20signs%20with%20photoluminescent%20and%20reflective%20materials%2C%20QCDD%20approved%20safety%20signage&width=300&height=200&seq=safety-signs-related&orientation=landscape',
      category: 'Signage',
      compliance: 'Photoluminescent'
    }
  ];

  return (
    <div className="min-h-screen">
      <ProductDetailHero product={product} />
      <ProductFeatures features={features} />
      <ProductSpecifications specifications={specifications} />
      <ComplianceSection />
      <RelatedProducts products={relatedProducts} />
      <ProductCTA />
      
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-8 right-8 z-50">
        <a 
          href="https://wa.me/97455544093"
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center justify-center group"
        >
          <i className="ri-whatsapp-line text-2xl group-hover:scale-110 transition-transform"></i>
        </a>
      </div>
    </div>
  );
}
